<cmps-dialog>
    <cmps-dialog-header>
        <div
            class="cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-min-h-50p"
        >
            <div
                class="cmps-cdk-font-bold cmps-cdk-font-size-14p cmps-cdk-flex-grow-1"
            >
                {{ _i18n._657_SELECT_A_USER | translate }}
            </div>
            <div>
                <button
                    class="cmps-icon-button--no-bg"
                    cmpsIconButton
                    [cmpsTooltipTrigger]="_i18n._763_CLOSE | translate"
                    (click)="overlay?.close()"
                >
                    <cmps-icon svgIcon="close"></cmps-icon>
                </button>
            </div>
        </div>
    </cmps-dialog-header>
    <cmps-dialog-body>
        <div class="cmps-cdk-overflow-x-hidden cmps-quick-access--users">
            <ng-container
                *ngFor="let user of _users; let first = first; let last = last"
            >
                <div
                    class="cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-min-h-50p cmps-cdk-pr-0dot25 hover:cmps-cdk-bg-color-grey-100 hover:cmps-cdk-color-blue-100 cmps-cdk-cursor-pointer"
                    [class.cmps-cdk-pl-0dot25]="first"
                    [class.cmps-cdk-pl-1]="!first"
                    [class.cmps-cdk-border-b-width-1p]="!last"
                    [class.cmps-cdk-border-b-solid]="!last"
                    [class.cmps-cdk-border-b-color-grey-100]="!last"
                    role="button"
                    tabindex="-1"
                    (click)="_onUserClick(user)"
                    (keydown.enter)="_onUserClick(user)"
                >
                    <div>
                        <cmps-icon
                            class="cmps-cdk-fill-blue-100 cmps-quick-access--icon"
                            svgIcon="account-circle"
                        ></cmps-icon>
                    </div>
                    <div
                        class="cmps-cdk-flex-grow-1 cmps-cdk-px-0dot5 cmps-cdk-font-size-12p"
                    >
                        {{ user.name }}
                    </div>
                    <div *ngIf="user.signedInUser">
                        <cmps-icon
                            class="cmps-cdk-fill-green-100"
                            svgIcon="account-outline"
                        ></cmps-icon>
                    </div>
                    <div *ngIf="user.favourite">
                        <cmps-icon
                            class="cmps-cdk-fill-yellow-100"
                            svgIcon="star"
                        ></cmps-icon>
                    </div>
                </div>
            </ng-container>
        </div>
    </cmps-dialog-body>
</cmps-dialog>
